export const formatUsers = (users: any, data: any) => {
  return users.map((user: any) => ({
    uuid: user.uuid,
    primary: user.display_name,
    secondary: `${
      data.location_uuid || data.is_multipost
        ? user.role_cockpit
        : user.role_cloud
    }`,
    initials: user.initials,
    color: user.user_color,
    data: { ...user }
  }));
};

export const formatUsersForTimeline = (
  users: any,
  roleTranslated: string,
  data: any
) => {
  return users.map((item: any) => ({
    uuid: item?.uuid,
    primary: item?.display_name,
    secondary: `${
      data.location_uuid || data.is_multipost
        ? item?.role_cockpit
        : item?.role_cloud
    } ${roleTranslated}`,
    initials: item?.initials,
    timeStamp: item?.is_approved_timestamp,
    approval: item?.is_approved,
    color: item?.user_color,
  }));
};
